import { multilingual_url } from '../utils/multilingual-url';
import { updateRecentlyViewed } from '../utils/cart';
import '../../styles/components/product-card.scss';

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.handle = this.getAttribute('handle');
    this.quickAddButton = this.querySelectorAll('[data-quick-add]');
    this.productFormSelect = this.querySelector('[name="id"]');

    if (this.quickAddButton.length >= 1) {
      this.quickAddButton.forEach(button => button.addEventListener('click', this.onQuickAddButtonClick.bind(this)));
    }

    this.product = JSON.parse(this.querySelector('[data-product]').innerHTML);
  }

  async onQuickAddButtonClick() {
    updateRecentlyViewed(this.product.handle);

    const drawerEvent = new CustomEvent('open-product-drawer', {
      detail: {
        action: 'purchase',
        product: {
          title: this.product.title,
          handle: this.product.handle,
          url: multilingual_url(`/products/${this.product.handle}`),
        },
        selectedVariantId: this.productFormSelect.value
      }
    });

    document.dispatchEvent(drawerEvent);
  }
}

try {
  customElements.define('product-card', ProductCard);
}
catch(e) {}
